export default (leasingData = []) => {
    const data = leasingData;
    let overallCostLease = 0;
    for (const { totalMonthlyCost = 0 } of data) {
        overallCostLease += totalMonthlyCost;
    }
    return overallCostLease;
};
